import type { Components } from '@mui/material';

export const MuiDialog: Components['MuiDialog'] = {
  styleOverrides: {
    paper: {
      borderRadius: '20px',
      padding: '40px 60px 20px 60px',
    },
  },
};